import { Popover } from 'baseui/popover';
import { filterPopoverOverridesStyles } from 'common/constants/styles';
import useToggleState from 'hooks/use-toggle-state';
import * as React from 'react';

import FilterControlContent from './filter-control-content';

export interface FilterControlProps {
  name?: string;
  children: (toggleFilter: () => void) => React.ReactElement;
}

export default function FilterControl(props: FilterControlProps) {
  const { children } = props;
  const [isOpen, handle] = useToggleState(false);

  return (
    <Popover
      overrides={filterPopoverOverridesStyles}
      content={() => (
        <FilterControlContent setIsOpen={handle.set} initialName={props.name} />
      )}
      isOpen={isOpen}
      onClick={handle.open}
      onClickOutside={handle.close}
      placement="right"
    >
      {children(handle.open)}
    </Popover>
  );
}
